import deviceWidth from "../getDeviceWidth/getDeviceWidth";

function getTileWidth(tilesCount: number, isMobile: boolean) {
    var onePercent = deviceWidth() * 0.01;
    var singleGirdContainerPadding = onePercent * 1; // sGCP + girdContainer + sGCP = deviceWidth()
    var singleTilePadding = onePercent * 2;
    if (!isMobile && singleTilePadding > 5) {
        // max desktop padding
        singleTilePadding = 5;
    }
    return (
        (
            (deviceWidth() - 2 * singleGirdContainerPadding - (tilesCount - 1) * singleTilePadding) /
            tilesCount
        ).toString() + "px"
    );
}

export default getTileWidth;
